// extracted by mini-css-extract-plugin
module.exports = {"Detail":"Detail_Detail__37Eyk","title":"Detail_title__3nQX0","titletext":"Detail_titletext__kRcsc"};